export default __webpack_public_path__ + "static/media/flag-new-zealand.deadb3d5.svg";